import React from "react";
import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { useEmpresasLanguage } from "../context/EmpresasLanguageContext";
import { construccionHub } from "../data/financialIntelligenceHealthcare";

function EmpresasConstruccion() {
  const { lang } = useEmpresasLanguage();
  const t = construccionHub[lang] || construccionHub.es;

  return (
    <div className="overflow-x-hidden bg-white">
      <section className="relative bg-[#0F172A] text-white">
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 30%, rgba(245,158,11,0.18), transparent 40%), radial-gradient(circle at 80% 0%, rgba(148,163,184,0.2), transparent 35%)",
          }}
        />
        <div className="relative max-w-6xl mx-auto px-6 sm:px-10 lg:px-16 py-16 lg:py-24">
          <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-amber-300">
            {t.eyebrow}
          </p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-semibold tracking-tight">{t.title}</h1>
          <p className="mt-5 text-lg text-slate-300 max-w-2xl leading-relaxed">{t.subtitle}</p>
        </div>
      </section>

      <section className="py-14 px-6 sm:px-10 lg:px-16">
        <div className="max-w-3xl mx-auto rounded-[2rem] border border-slate-200 bg-slate-50 p-8 sm:p-10">
          <div className="h-12 w-12 rounded-2xl bg-amber-50 border border-amber-100 flex items-center justify-center mb-5">
            <Building2 className="w-6 h-6 text-amber-600" />
          </div>
          <p className="text-slate-600 text-lg leading-relaxed">{t.body}</p>
          <a
            href={t.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center justify-center rounded-full bg-[#0F172A] px-7 py-3.5 text-sm font-semibold text-white hover:bg-slate-800 transition"
          >
            {t.cta}
          </a>
          <div className="mt-8">
            <Link to="/empresas" className="text-sm font-medium text-slate-500 hover:text-[#0F172A] transition">
              ← {t.back}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default EmpresasConstruccion;
